
enum WsActionType {
  None    = 0,
  Test    = 1,
  Defer   = 2,
  Upgrade = 3,
  Replace = 4,
  Remove  = 5
}




enum WsReadinessStatus {
  NotReady      =   0,
  ActionPending =   1,
  TestPending   =  10,
  TestRunning   =  11,
  TestFailed    =  12,
  Upgrade       =  30,
  Replace       =  40,
  Remove        =  50,
  Ready         = 100,
  ReadyDefer    = 101,
  ReadyTest     = 111,
  ReadyUpgrade  = 131,
  ReadyReplace  = 141,
  ReadyRemove   = 151
}




enum WsSalesOrganizationType {
  None      = "",
  Admin     = "ADMIN",
  Avanade   = "AVANADE",
  Accenture = "ACCENTURE",
  HP        = 'HP',
  Client    = 'CLIENT'
}




enum WsDeliverTenantStatus {
  Ready      = 'READY',
  Complete   = 'COMPLETE',
  InProgress = 'IN_PROGRESS',

  SyncInProgress   = 'SYNC_IN_PROGRESS',
  BackupInProgress = 'BACKUP_IN_PROGRESS',

  CloneInProgress   = 'CLONE_IN_PROGRESS',
  RestoreInProgress = 'RESTORE_IN_PROGRESS',

  Failed     = 'FAILED',
  Incomplete = 'INCOMPLETE',
  Disabled   = 'DISABLED'
}




enum WsDeliverConfigWorkload {
  NotSet             = '',
  Container          = 'CONTAINER',
  EntraId            = "ENTRAID",
  Exchange           = "EXCHANGE",
  Intune             = "INTUNE",
  Office365          = "OFFICE365",
  OneDrive           = 'ONEDRIVE',
  Planner            = 'PLANNER',
  PowerPlatform      = 'POWERPLATFORM',
  SecurityCompliance = "SECURITYCOMPLIANCE",
  SharePoint         = 'SHAREPOINT',
  Teams              = 'TEAMS'
}




enum WsDeliverConfigItemType {
  NotSet          = 'NOT_SET',
  Resources       = 'RESOURCES', // can only be instance of Resource
  Resource        = 'RESOURCE',  // can only be instance of Resource
  Instance        = 'INSTANCE',  // can be instance of Resource, String, Number, Boolean
  String          = 'STRING',
  Number          = 'NUMBER',
  Boolean         = 'BOOLEAN',
  ListOfResources = 'LIST_OF_RESOURCES',
  ListOfStrings   = 'LIST_OF_STRINGS',
  ListOfNumbers   = 'LIST_OF_NUMBERS',
  ListOfBooleans  = 'LIST_OF_BOOLEANS'
}




enum WsDeliverConfigSchemaMappingStatus {
  Review   = 'REVIEW',
  Mapped   = 'MAPPED',
  ReadOnly = 'READ_ONLY',
  Ignore   = 'IGNORE',
  Missing  = 'MISSING',
  Removed  = 'REMOVED'
}








enum WsDecodeClassification {
  None        = 'NONE',

  User        = 'USER',
  Device      = 'DEVICE',
  Application = 'APPLICATION',
  Platform    = 'PLATFORM',
  Service     = 'SERVICE',
  Security    = 'SECURITY',
  Physical    = 'PHYSICAL',

  Executive    = 'EXECUTIVE',
  OfficeWorker = 'OFFICE_WORKER',
  Developer    = 'DEVELOPER',
  RemoteWorker = 'REMOTE_WORKER'
}




enum WsDecodeMeasurement {
  Average  = 'AVERAGE',
  Count    = 'COUNT',
  Sum      = 'SUM'
}




enum WsDecodeScoreView {
  Score   = 'SCORE',
  // Number  = 'NUMBER',
  Percent = 'PERCENT',
  Value   = 'VALUE'
}




const getScoreView = (value: string) => {
  if (value === 'VALUE') {
    return WsDecodeScoreView.Value;
  } else if (value === 'PERCENT') {
    return WsDecodeScoreView.Percent;
  } else {
    return WsDecodeScoreView.Score;
  }
};




const getOrganizationType = (organizationType: string | undefined) => {
  if (`${organizationType}` === 'ADMIN') {
    return WsSalesOrganizationType.Admin;

  } else if (`${organizationType}` === 'AVANADE') {
    return WsSalesOrganizationType.Avanade;

  } else if (`${organizationType}` === 'ACCENTURE') {
    return WsSalesOrganizationType.Accenture;

  } else if (`${organizationType}` === 'HP') {
    return WsSalesOrganizationType.HP;

  } else {
    return WsSalesOrganizationType.None;
  }
};

const getOrganizationName = (organizationType: WsSalesOrganizationType) => {
  if (organizationType === WsSalesOrganizationType.Admin) {
    return 'Admin';

  } else if (organizationType === WsSalesOrganizationType.Avanade) {
    return 'Avanade';

  } else if (organizationType === WsSalesOrganizationType.Accenture) {
    return 'Accenture';

  } else if (organizationType === WsSalesOrganizationType.HP) {
    return 'HP';

  } else {
    return '-';
  }
};

const getOrganizationTypeByRole = (role: string | undefined): WsSalesOrganizationType => {

  if (`${role}`.startsWith('ACCENTURE_')) {
    return WsSalesOrganizationType.Accenture;

  } else if (`${role}`.startsWith('HP_')) {
    return WsSalesOrganizationType.HP;

  } else if (`${role}`.startsWith('CLIENT')) {
    return WsSalesOrganizationType.Client;

  } else {
    return WsSalesOrganizationType.Avanade;
  }
};




export {
  getScoreView,
  getOrganizationType,
  getOrganizationTypeByRole,
  getOrganizationName,
  WsDecodeScoreView,
  WsDecodeClassification,
  WsDecodeMeasurement,
  WsActionType,
  WsReadinessStatus,
  WsSalesOrganizationType,
  WsDeliverTenantStatus,
  WsDeliverConfigWorkload,
  WsDeliverConfigItemType,
  WsDeliverConfigSchemaMappingStatus
};
